import { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';

import * as Styled from './ComparePackagesModal.styles';
import Package from './Package';

const ComparePackagesModal = ({ plans }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('m') === 'comparePackages') {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [searchParams]);

  const handleClose = () => {
    setSearchParams((params) => {
      params.delete('m');
      return params;
    });
  };

  return (
    <Styled.Root
      onClose={handleClose}
      open={isOpen}
    >
      <Styled.Container gap={4}>
        <Heading size="xl" width="85%">
          {plans.title && <FormattedMessage id={plans.title} />}
        </Heading>
        <Styled.Content>
          {plans.items.map((plan) => (
            <Package plan={plan} key={plan.name} />
          ))}
        </Styled.Content>
      </Styled.Container>
      <Styled.CloseButton onClick={handleClose} icon={<CloseIcon />} label="Close Button" />
    </Styled.Root>
  );
};

ComparePackagesModal.propTypes = {
  plans: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        service: PropTypes.string,
        features: PropTypes.arrayOf(PropTypes.string),
        disabledFeatures: PropTypes.arrayOf(PropTypes.string),
        tag: PropTypes.shape({
          label: PropTypes.string,
          color: PropTypes.string
        }),
        icon: PropTypes.shape({
          src: PropTypes.string,
          color: PropTypes.string,
          bgColor: PropTypes.string
        })
      })
    ).isRequired
  }).isRequired
};
export default ComparePackagesModal;
